import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { OverViewAddPenalty, OverViewPoolPoint, OverViewScrubberPoint } from 'src/app/interface/overview.interface';
import { DistributionDataService } from 'src/app/services/distributionData.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';

@Component({
  selector: 'app-fleet-ship-detail',
  templateUrl: './fleet-ship-detail.component.html',
  styleUrls: ['./fleet-ship-detail.component.scss']
})
export class FleetShipDetailComponent implements OnInit {
  selectedPagetab: string = 'overview';
  penaltyText:string = 'Add penalty';
  endpenaltyText:string = 'End penalty';
  showPointsTab: boolean = false;
  storeVslnumber: any;
  shipDetailsbasicinfo: any;
  poolPointDetails: any;
  openPenaltyModal:boolean = false;
  openEndPenaltyModal: boolean = false;
  public subscription: Subscription;
  penaltyForm: any;
  penaltyDates: string = '';
  penaltyEndDates:string = '';
  penaltyResons: string = '';
  penaltydateOnly: any;
  penaltytimeOnly: any;
  penaltyenddateOnly:any;
  penaltyendtimeOnly:any;
  addPenaltydetails:any;
  openPenaltyFlow: string = '';
  showPenalty:boolean = false;
  endPenaltyDetails: any;
  calculatedPenaltyVal: any;
  removePenalty:boolean = false;
  removePenaltyReasons: string = '';
  isUsedinCalculation: boolean = true;
  removePenaltyPageLoadData: any;

  toolTipConfig: {
    width: "auto"
  }
  penaltyHistory: boolean = false;
  scrubberPointDetails: any;
  isScrubberVisible: any;
  overViewPoolPointInterface:OverViewPoolPoint = {
    isLoader: true
  };
  overViewScrubberPointInterface:OverViewScrubberPoint= {
    isLoader: true
  };
  overViewPenaltyInterface:OverViewAddPenalty= {
    isLoader: true
  };
  constructor(private vesselService:VesselsService,
    private router:Router,
    private distributionService:DistributionDataService,
    private toasterService: ToasterService,
    private datePipe: DatePipe) {    
      this.selectedPagetab = 'overview'
  }

  ngOnInit() {
    this.selectedPagetab = 'overview'
    this.storeVslnumber = this.vesselService.vesselNumber;
    console.log( this.storeVslnumber)
    
    if( this.storeVslnumber){
      this.getShipDetails();
      //this.callGetPoolPointDetails(); //fetch condition boolean for pool point
    }
    this.subscription =  this.distributionService.changeFleet.subscribe((res:any)=>{
      if(res){
        this.goBack();
      }
    })
    this.subscription = this.vesselService.saveSelectedTab.subscribe((res:any)=>{
      if(res){
        this.penaltyHistory = res;
        console.log(this.penaltyHistory)
      }
    })

    this.subscription = this.vesselService.$pointsMngEvent.subscribe((res:any)=>{
      if(res){
        this.selectedPagetab = 'pointsManagement';
      }
    })
   
  }
  getShipDetails(){
    this.overViewPoolPointInterface.isLoader = true;
    this.overViewPenaltyInterface.isLoader = true;
    this.vesselService.getVesselDetail(this.storeVslnumber).subscribe({
      next:(res:any)=>{
        console.log(res)
        this.shipDetailsbasicinfo = res?.data?.getVessel?.vessel;
        this.vesselService.storePoolval = res?.data?.getVessel?.vessel?.subPool;
        this.overViewPoolPointInterface.isLoader = false;
        this.overViewPenaltyInterface.isLoader = false;
        // if(this.shipDetailsbasicinfo?.isPenaltyOngoing){
        //   this.showPenalty = true;
        // }else{
        //   this.showPenalty = false;
        // }
        this.callGetPoolPointDetails()
        
      },
      error:(error:any)=>{

      }
    })

   }

  clickTab(val: any) {
    this.selectedPagetab = val;
    if(this.selectedPagetab === 'overview'){
      this.getShipDetails();
    }
    
  }

  goBack(){
    this.vesselService.storePoolval = '';
    this.vesselService.storegetPoolData = [];
    this.router.navigate(["fleetmanagement"])
    this.distributionService.changeFleet.next(false);
    this.vesselService.saveSelectedTab.next(false);

  }
  goBackToPool(){
    console.log(this.vesselService.storePoolval)
    this.router.navigate(["fleetmanagement"])
    this.distributionService.changeFleet.next(false);
    this.vesselService.saveSelectedTab.next(false);
  }
  
  // penaltyHistory(){
  //   this.selectedPagetab = 'penaltyHistory'
  // }
 
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // callGetPoolPointDetails(){
  //   let input = {"vslNumber": this.storeVslnumber};
  //   this.vesselService.getPoolPointDetails(input).subscribe({
  //     next:(res:any)=>{
  //       console.log(res)
  //       if(res.data.getPoolPointDetails.success){
  //         this.poolPointDetails = res.data.getPoolPointDetails.data;
  //       }
  //       else{
  //         this.notifyService.showError('Error', res.data.getPoolPointDetails.message);
  //       }
  //     },
  //     error:(error:any)=>{
  //       this.notifyService.showError('Error', error);
  //     }
  //   })
  // }

  callGetPoolPointDetails(){
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getPoolPointDetails(input).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res.data.getPoolPointDetails.success){
          this.poolPointDetails = res.data.getPoolPointDetails.data;
          // this.updatePoolPointsData = {};
        }
        else{
          this.toasterService.openToast('Error', res.data.getPoolPointDetails.message);
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  callGetScrubberPointDetails(){
    // this.overViewScrubberPointInterface.isLoader = true;
    let input = {"vslNumber": this.shipDetailsbasicinfo?.vslNumber};
    this.vesselService.getScrubberPointDetails(input).subscribe({
      next:(res:any)=>{
        console.log(res)
        if(res?.data?.getScrubberPointDetails?.success){
          this.scrubberPointDetails = res?.data?.getScrubberPointDetails?.data;
          this.overViewScrubberPointInterface.isLoader = false;
          console.log(this.scrubberPointDetails)
        }
        else{
          this.toasterService.openToast('Error', res?.data?.getScrubberPointDetails?.message);
        }
       
        
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
      }
    })
  }
  showScrubber(e:any){
    console.log(e);
    this.overViewScrubberPointInterface.isLoader = true;
    this.isScrubberVisible = e;
    if(this.isScrubberVisible?.currentScrubberUsage){
      this.callGetScrubberPointDetails();
    }   
  }
}
